import { render } from "./EventsPage.vue?vue&type=template&id=11a95afb&scoped=true"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"

import "./EventsPage.vue?vue&type=style&index=0&id=11a95afb&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Ollie\\Apps\\lasource-hautesalpes\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11a95afb"]])

export default __exports__